import { __assign } from "tslib";
import React from 'react';
import classNames from 'classnames';
import IndeterminateCheckBoxIcon from '../internal/svg-icons/IndeterminateCheckBox';
import CheckBoxOutlineBlank from '../internal/svg-icons/CheckBoxOutlineBlank';
import CheckBox from '../internal/svg-icons/CheckBox';
import BaseToggleButton from './BaseToggleButton';
var checkedCheckboxIcon = React.createElement(CheckBox, null);
var checkboxIcon = React.createElement(CheckBoxOutlineBlank, null);
var indeterminateCheckboxIcon = React.createElement(IndeterminateCheckBoxIcon, null);
export default function BaseCheckboxButton(props) {
    var checked = props.checked, disabled = props.disabled, inputProps = props.inputProps, inputRef = props.inputRef, name = props.name, onChange = props.onChange, tabIndex = props.tabIndex, value = props.value, className = props.className, readOnly = props.readOnly, indeterminate = props.indeterminate, dense = props.dense, onClick = props.onClick;
    var _icon = indeterminate
        ? indeterminateCheckboxIcon
        : checked
            ? checkedCheckboxIcon
            : checkboxIcon;
    return (React.createElement(BaseToggleButton, { checked: checked, disabled: disabled || readOnly, className: classNames('sinoui-checkbox-button', className), color: props.color, dense: dense, onClick: onClick },
        _icon,
        React.createElement("input", __assign({ className: classNames('sinoui-checkbox-button-input', props.inputClassName), type: "checkbox", name: name, checked: checked, onChange: onChange, disabled: disabled, readOnly: readOnly, tabIndex: tabIndex, value: value, ref: inputRef }, inputProps))));
}
//# sourceMappingURL=BaseCheckboxButton.js.map